{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')('member_large_avatar')

module.exports = t.renderable ({ avatarHash, viewTitle }) ->
  title = viewTitle
  t.img { src: [avatarDomain, avatarHash, 'original.png'].join('/'), alt: title, title }
